import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ItemPage } from '#features/work-items/components/item-page';
import { useBackToList, useSwitchItemPage } from '#features/work-items/item-navigation';

const ItemRoute = () => {
  const { ref } = Route.useParams();
  const navigate = useNavigate();
  const switchItem = useSwitchItemPage();
  const back = useBackToList(ref);

  return (
    <ItemPage
      itemRef={ref}
      onOpen={switchItem}
      onBack={back}
      onMissing={() => void navigate({ to: '/my' })}
    />
  );
};

/**
 * La vista completa de un item. La clave sola basta como dirección: ya lleva el proyecto
 * dentro, y `work_item_aliases` la sigue resolviendo después de un `move-project`, así que el
 * enlace no caduca ni se queda mintiendo sobre en qué proyecto está.
 */
export const Route = createFileRoute('/_authed/item/$ref')({
  component: ItemRoute,
});
